<div class="chatbot-container">
  <div class="chatbot-header">
    <div class="emily-wrapper">
      <img class="emily-logo" src="/assets/images/knowledge-base/avatar-emily.png" alt="Emily Logo" />
      <span class="emily-text">Emily AI</span>
    </div>
    <button
      class="open-in-new-tab"
      (mouseenter)="showOpenText.set(true)"
      (mouseleave)="showOpenText.set(false)"
      (click)="openChatbotInNewTab()"
    >
      @if (showOpenText()) {
        <span>Open Knowledge Base</span>
      }
      <mat-icon> open_in_new </mat-icon>
    </button>
  </div>
  <div class="chat-messages-content" #messagesContainer>
    <div class="messages-container">
      <!-- AI Message Example -->
      <div class="message-row ai-message-row">
        <div class="ai-avatar">
          <img src="/assets/images/knowledge-base/avatar-emily.png" alt="Emily AI" />
        </div>
        <div class="message ai-message">
          <p>Hello! I’m Emily, your AI Scoot Assistant! How can I help you?</p>
        </div>
      </div>

      @for (message of messages(); track message; let i = $index) {
        @if (message.sender === 'bot') {
          <div class="ai-message-wrapper ai-message-row">
            <div
              class="message-row ai-message-row"
              [ngClass]="{
                'message-animating': message.animationState === 'animating',
                'message-animated': message.animationState === 'animated',
              }"
            >
              <div class="ai-avatar">
                <img src="/assets/images/knowledge-base/avatar-emily.png" alt="Emily AI" />
              </div>
              <div class="message ai-message">
                <markdown class="in-room-chat-bot" [data]="message.text"></markdown>
              </div>
            </div>
            <div class="message-footer">
              <p class="message-time">{{ message.time | date: 'shortTime' }}</p>
              <div class="feedback-buttons">
                <button
                  matTooltip="Good response"
                  [attr.data-feedback]="message.feedback === true"
                  class="thumbs-up"
                  (click)="sendFeedback(message.text, true, i)"
                >
                  <mat-icon>thumb_up</mat-icon>
                </button>
                <button
                  matTooltip="Bad response"
                  [attr.data-feedback]="message.feedback === false"
                  class="thumbs-down"
                  (click)="sendFeedback(message.text, false, i)"
                >
                  <mat-icon>thumb_down</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }

        @if (message.sender === 'user') {
          <div
            class="message-row user-message-row"
            [ngClass]="{
              'message-animating': message.animationState === 'animating',
              'message-animated': message.animationState === 'animated',
            }"
          >
            <div class="message user-message">
              <markdown class="in-room-chat-bot" [data]="message.text"></markdown>
            </div>
            <div class="user-avatar">
              <mat-icon>account_circle</mat-icon>
            </div>
          </div>
        }
      }

      @if (!hasStartedChat()) {
        <div class="initial-pre-made-questions-wrapper">
          @for (sampleMessage of sampleMessages(); track sampleMessage) {
            @if (!sampleMessage.hasStartedChat) {
              <button class="pre-made-question" (click)="sendMessage(sampleMessage.prompt, $event)">
                {{ sampleMessage.text }}
              </button>
            }
          }
        </div>
      }

      @if (isLoading()) {
        <div class="message-row ai-message-row">
          <div class="ai-avatar">
            <img src="/assets/images/knowledge-base/avatar-emily.png" alt="Emily AI" />
          </div>
          <div class="message ai-message loading-dot">
            <div class="typing">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <div class="chat-input-container">
    <!-- THIS IS GOING TO BE IMPLEMENTED LATER -->
    <!-- @if (hasStartedChat) {
      <div class="pre-made-questions-wrapper">
        @for (sampleMessage of sampleMessages; track sampleMessage) {
          @if (sampleMessage.hasStartedChat) {
            <button class="pre-made-question" (click)="sendMessage(sampleMessage.prompt)">
              {{ sampleMessage.text }}
            </button>
          }
        }
      </div>
    } -->
    <div class="message-container">
      <input
        [(ngModel)]="newMessage"
        type="text"
        class="message-input"
        placeholder="Type your message here..."
        aria-label="Message input"
        (keyup.enter)="sendMessage()"
        (keydown)="onMessageKeyDown($event)"
      />
      <button class="send-button" aria-label="Send message" (click)="sendMessage()">
        <mat-icon class="arrow-icon">arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
